<script setup lang="ts">
// Site-wide backdrop: three drifting colour blobs (wordmark blue, violet,
// pink) with a cyan accent, under film grain, fixed behind every route so
// no page is ever a flat navy slab. Pure CSS; static under reduced motion.
</script>

<template>
  <div class="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
    <div class="blob-drift-a absolute -left-[20vw] -top-[25vh] size-[70vw] rounded-full bg-primary/50 blur-[120px]"></div>
    <div class="blob-drift-b absolute -right-[22vw] top-[5vh] size-[62vw] rounded-full bg-featured/50 blur-[130px]"></div>
    <div class="blob-drift-c absolute left-[30vw] top-[55vh] size-[48vw] rounded-full bg-pink/30 blur-[140px]"></div>
    <div class="absolute -bottom-[20vh] -left-[10vw] size-[40vw] rounded-full bg-cyan/22 blur-[140px]"></div>
    <div class="absolute inset-0 bg-gradient-to-b from-bg/20 via-bg/55 to-bg/80"></div>
    <div class="bg-grain absolute inset-0 opacity-80 mix-blend-overlay"></div>
  </div>
</template>
